import type { EventHandler, MouseEvent } from "react"

export const captureClick: EventHandler<MouseEvent> = (e) => e.stopPropagation()
